import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from '../../_alert';
import { AppConfig } from '../../app.config';
import { LoginPopupComponent } from '../../components/login-popup-modal/login-popup/login-popup.component';
import { DatastoreService } from '../../services/datastore.service';
import { ApiService } from '../../services/jrni/api.service';
import { ClientService } from '../../services/jrni/client.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { LoginService } from '../../services/jrni/login.service';
import { MemberService } from '../../services/jrni/member.service';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  selectedDepartment;
  pageTitle: string;
  registerPageText: string;
  customerQuestions = [];
  emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  // passwordRegex = /^.*(?=.{12,})(?=.*[a-zA-Z])(?=.*[A-Z])(?=.*\d).*$/;
  submitted: boolean;
  requiresFullRegistration = false;
  allowsMembers: boolean;
  bookingQuestionsConfig = AppConfig.settings.bookingQuestions;
  showingAddresses: boolean = false;
  // isInLocalArea: boolean;
  addresses: any = [];
  custodianCodes: any;
  selectedAddressId: number;
  canSubmit: any = false;
  maxChildren: number = 3
  hide: boolean = true;
  hideConfirmPassword: boolean = true;
  extraForms: any = {}

  constructor(
    private departmentService: DepartmentService,
    private router: Router,
    private dialog: MatDialog,
    private alertService: AlertService,
    private translateService: TranslateService,
    private apiService: ApiService,
    private datastoreService: DatastoreService,
    private clientService: ClientService,
    private memberService: MemberService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService
  ) { }

  // Initialise the form
  customerForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex)]),
    confirmEmail: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex)]),
    password: new FormControl('', Validators.compose([Validators.required])),
    confirm_password: new FormControl('', Validators.compose([Validators.required])),
  }, {
    validators: this.matchingEmailsAndPasswordsValidator('email', 'confirmEmail', 'password', 'confirm_password')

  });

  // Getter for easy access to form fields
  get form() {
    return this.customerForm.controls;
  }

  // On input entry checks if email and confirm email match
  matchingEmailsAndPasswordsValidator(emailKey: string, confirmEmailKey: string, passwordKey: string, confirmPasswordKey: string,): ValidatorFn {
    return (group: FormGroup): { [key: string]: any } => {

      let email = group.controls[emailKey];
      let confirmEmail = group.controls[confirmEmailKey];
      let password = group.controls[passwordKey];
      let confirmPassword = group.controls[confirmPasswordKey];

      const checkE = this.checkMissMatch(email, confirmEmail)
      const checkP = this.checkMissMatch(password, confirmPassword)
      const checkPV = this.invalidPassword(password)
      let returnValue = {}
      if (checkE || checkP) {
        returnValue["mismatch"] = true
      }
      if (checkPV) {
        returnValue["pattern"] = true
      }

      return returnValue
    };
  }

  checkMissMatch(email, confirmEmail) {
    // If the email and confirm email inputs have data
    if (email.value.length > 0 && confirmEmail.value.length > 0) {
      // Check if the emails match
      if (email.value !== confirmEmail.value) {
        confirmEmail.setErrors({ mismatch: true });
        return true
      } else if (confirmEmail.errors && confirmEmail.errors.mismatch) {
        // If the errors object does not contain any other errors then set errors {} to null
        if (Object.keys(confirmEmail.errors).length == 1) {
          confirmEmail.setErrors(null);
        } else {
          // Delete the mismatch error from the object as we do not want to remove any other errors that exist in the {}
          delete confirmEmail.errors.mismatch;
        }
        return false;
      }
    }
  }

  invalidPassword(password) {
    if (password.value.length < 12) {
      this.setPasswordValid(false, password)
      return true
    }
    let validCheckCount = 0
    let regex = /[a-z]/gm
    if (password.value.match(regex)) {
      validCheckCount++
    }
    regex = /[A-Z]/gm
    if (password.value.match(regex)) {
      validCheckCount++
    }
    regex = /[0-9]/gm
    if (password.value.match(regex)) {
      validCheckCount++
    }
    regex = /[^A-Za-z0-9\s]/gm
    if (password.value.match(regex)) {
      validCheckCount++
    }
    console.log("validCheckCount", validCheckCount)
    if (validCheckCount >= 3) {
      this.setPasswordValid(true, password)
      return false
    } else {
      this.setPasswordValid(false, password)
      return true
    }
  }

  setPasswordValid(valid, password) {
    if (!valid) {
      password.setErrors({ pattern: true });
      return true
    } else if (password.errors && password.errors.pattern) {
      // If the errors object does not contain any other errors then set errors {} to null
      if (Object.keys(password.errors).length == 1) {
        password.setErrors(null);
      } else {
        // Delete the mismatch error from the object as we do not want to remove any other errors that exist in the {}
        delete password.errors.pattern;
      }
      return false;
    }
  }


  routerGoBack() {
    this.router.navigate(['/login']);
  }

  restartJourney() {
    this.router.navigate(['/login']);
  }

  ngOnInit() {
    this.scrollToTop();
    this.spinner.show();
    // Use this.departmentService.getLocation() if the services are set on the children departments
    // Use this.departmentService.get() if the services are set on the parent department
    let parentDepartment = this.datastoreService.parentDepartment
    if (parentDepartment === undefined) {
      this.restartJourney();
    } else {
      this.selectedDepartment = parentDepartment;
      let registrationOption;
      // Get the configurable data
      if (this.selectedDepartment.hasOwnProperty('extra')) {
        // Set the title on the login page to the title from the business question
        this.datastoreService.parentDepartment.extra.hasOwnProperty('register_page_title') ? this.pageTitle = this.datastoreService.parentDepartment.extra.register_page_title : this.pageTitle = "Registration title not set";
        // Set the extra text on the page to the text taken from the business question
        this.datastoreService.parentDepartment.extra.hasOwnProperty('register_page_sub_title') ? this.registerPageText = this.datastoreService.parentDepartment.extra.register_page_sub_title : null;
        // Get the registration option
        // this.selectedDepartment.extra.hasOwnProperty('registration_option') ? registrationOption = this.selectedDepartment.extra.registration_option : null;
      }


      // If the register option is set to complete a full registration then capture the following details
      // if (registrationOption.toLowerCase() === 'register complete details') {
      this.requiresFullRegistration = true;
      this.customerForm.addControl('first_name', new FormControl('', Validators.required));
      this.customerForm.addControl('last_name', new FormControl('', Validators.required));
      this.customerForm.addControl('mobile', new FormControl('', [Validators.minLength(5)]));
      // this.customerForm.addControl('selectedAddress', new FormControl('', Validators.required));
      // this.customerForm.addControl('postcode', new FormControl('', Validators.required));
      // }
      this.spinner.hide();

      // Get the customer questions
      this.departmentService.getCustomerQuestions().then(questions => {
        this.customerQuestions = questions;

        for (let index = 0; index < this.customerQuestions.length; index++) {
          const question = this.customerQuestions[index];
          question.visible = false;
          question.reference = question.id;
          if (!question.admin_only) {
            if (!question.settings.hasOwnProperty('conditional_question')) {
              question.visible = true;
            }

            const questionControl = question.id;
            if (question.default == 1 && question.detail_type == 'check' || question.default == 1 && question.detail_type == 'check-price') {
              this.customerForm.addControl(questionControl, new FormControl(true));
            } else {
              this.customerForm.addControl(questionControl, new FormControl(''));
            }
          }
        }
        this.spinner.hide();
      }, err => {
        console.log(err)
        this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
        this.spinner.hide();
      });
    }
  }

  onQuestionChange() {
    const customerQuestions = this.customerQuestions
    // Conditional questions logic
    for (let index = 0; index < customerQuestions.length; index++) {
      const q = customerQuestions[index];
      // If the question has settings and relies on a conditional question
      if (q.settings && q.settings.hasOwnProperty('conditional_question')) {
        // Get the conditional question based on the id set in q
        const conditionalQ = customerQuestions.filter(question => question.id == q.settings.conditional_question);
        // Get the question control
        const questionControl = this.form[q.settings.conditional_question];
        // If the question control has a value get the option from the contional question. This will allow
        // us to check if q is shown when value is selected
        const option = conditionalQ[0].options.filter(option => option.name == questionControl.value);

        // If the conditional question is visible and the value chosen === to qs conditional answer then show q
        if (conditionalQ.length > 0 && conditionalQ[0].visible && option.length > 0 && q.settings.conditional_answers.hasOwnProperty(option[0].id)) {
          this.form[q.id].enable();
          // If the condiditonal question is important, Hide it
          if (q.important) {
            q.visible = false;
          } else {
            q.visible = true;
          }
        } else {
          q.visible = false;
          this.form[q.id].setValue('');
          this.form[q.id].disable();
        }
      }
    }
  }

  async test(formStatus: any) {
    console.log(`form status:`, formStatus);
    if (formStatus.status) {
      this.extraForms[formStatus.formId] = formStatus.data
    } else {
      this.extraForms[formStatus.formId] = formStatus.status
    }
    if (this.extraForms['address_registration_form'] && this.extraForms['vehicle_registration_form']) {
      this.canSubmit = true
    } else {
      this.canSubmit = false
    }
  }


  async onSubmit() {
    this.customerForm.markAllAsTouched();
    this.submitted = true;

    if (!this.extraForms["address_registration_form"] || !this.extraForms["vehicle_registration_form"]) {
      this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
      this.scrollToTop();
      return;
    }

    for (let index = 0; index < this.customerQuestions.length; index++) {
      const question = this.customerQuestions[index];
      if (question.id === this.bookingQuestionsConfig.schoolNameSelectionAccounts) {
        const test = question.options.filter(option => option.name == this.customerForm.value[this.bookingQuestionsConfig.schoolNameSelectionAccounts]);
        test.length > 0 ? this.customerForm.controls[this.bookingQuestionsConfig.schoolNameSelectionAccounts].setErrors(null) : this.customerForm.controls[this.bookingQuestionsConfig.schoolNameSelectionAccounts].setErrors({ 'selectedSchoolErr': "Please select a school from the list" });
      }
    }
    console.log(this.customerForm || !this.canSubmit)
    if (this.customerForm.invalid) {
      this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
      this.scrollToTop();
      return;
    } else {
      const needLogin = await this.checkIfDupeUser()
      if (needLogin.dupe) {
        return;
      }
      if (!this.requiresFullRegistration) {
        // Get the question that will act as the last name of the client
        this.customerForm.value.last_name = this.form[this.selectedDepartment.extra.registration_question_name].value;
      }
      // console.log(this.customerForm.value['confirmEmail'])
      // this.customerForm.get('362').setValue(this.customerForm.value['confirmEmail'])

      // Set the answers on the customer form being passed in as the client
      this.customerForm.value.questions = [];

      // For each question in the form check if the customer question exists and if so add to customerAnswers []
      for (const control in this.form) {
        if (this.form.hasOwnProperty(control)) {
          const element = this.form[control];
          const question = this.customerQuestions.filter(question => question.id.toString() === control);

          if (question.length > 0 && element.value.length > 0) {
            // Set a question object
            const q = {
              id: question[0].id,
              answer: element.value
            }
            this.customerForm.value.questions.push(q);
          }
        }
      }
      console.log(this.customerForm.value)
      // Create client
      this.spinner.show();

      const clientExists = await this.clientService.create(this.selectedDepartment, this.customerForm.value);

      if (clientExists && clientExists.auth_token) {
        await this.memberService.setMember(clientExists);
        this.loginService.setLogin(clientExists, null);

        // if(!this.extraForms["address_registration_form"] || !this.extraForms["vehicle_registration_form"]){
        // now save forms

        let form_no: number = 1;
        for (let address of this.extraForms["address_registration_form"]) {
          const addressBody = {
            'address_no': form_no,
            'postcode': address.value['postcode'],
            'address': address.value['address'],
          }
          await this.apiService.saveHwrcAddressForm(clientExists.id, this.selectedDepartment.id, addressBody)
          form_no++
        }

        form_no = 1
        for (let vehicle of this.extraForms["vehicle_registration_form"]) {
          const addressBody = {
            'vehicle_no': form_no,
            'mode_of_transport': vehicle.value['mode_of_transport'],
            'vehicle_registration': vehicle.value['vehicle_registration'],
            'vehicle_make': vehicle.controls['vehicle_make'].value,
            'vehicle_colour': vehicle.controls['vehicle_colour'].value,
            'is_this_a_restricted_vehicle': vehicle.value['is_this_a_restricted_vehicle'],
            'vehicle_type': vehicle.value['vehicle_type'],
            'other_vehicle': vehicle.value['other_vehicle'],
          }
          await this.apiService.saveHwrcVehicleForm(clientExists.id, this.selectedDepartment.id, addressBody)
          form_no++
        }
        this.spinner.hide();

        this.router.navigate(['/departments']);

      } else if (clientExists && clientExists.response.status == 401) {
        this.alertService.warn(this.translateService.instant('REGISTRATION.ACCOUNT_EXISTS', { email: this.customerForm.value.email }));
        this.spinner.hide()
        this.scrollToTop();
      } else {
        this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
        this.spinner.hide()
        this.scrollToTop();
      }
    }
  }


  async showDialog(user) {
    console.log("showlg")
    const dialogRef = this.dialog.open(LoginPopupComponent, {
      width: '1000px',
      // position: {top: '100px'} ,
      data: {
        header: this.translateService.instant('An account is already registered with your email address. Please login to continue.'),
        action: "login",
        user: user,
        // location,
        // member: this.member
      }
    });
  }

  async checkIfDupeUser() {
    const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const res = this.customerForm.value.email.match(emailRegex)
    console.log(res)
    let checkUser: any = false
    if (res.length > 0) {
      checkUser = await this.apiService.checkEmailAndName(
        this.customerForm.value.email,
        this.departmentService.selectedDepartment.id
      );
      if (checkUser) {
        // continue if user not found or if jrni account is a contact
        if (checkUser.detail !== "Not Found" && (checkUser.client_type !== "Contact")) {
          this.customerForm.controls["email"].setValue("")
          this.customerForm.controls["email"].patchValue("")
          this.datastoreService.selectedDepartment = null
          this.showDialog(checkUser);
          return { dupe: true, checkUser: checkUser }
        }
      }
    }
    return { dupe: false, checkUser: checkUser }
  }

  removeSpaces(controlName: string) {
    const control = this.customerForm.get(controlName);
    if (control && control.value) {
      const va = control.value.toLowerCase().replace(/\s+/g, '')
      control.setValue(va.toLowerCase(), { emitEvent: false });
    }
  }

  // scroll to the top of the page
  scrollToTop() {
    window.scroll(0, 0);
  }

  // Number input text validation, keycode 8 is backspace
  keyPressNumberField(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}